import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { useApiUrl } from '@/hooks/useApiUrl'

interface PrivateRouteProps {
  children: React.ReactNode
}

export const SSO_RETURN_KEY = 'sso:returnPath'

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth()
  const { isDcp } = useApiUrl()

  if(!isAuthenticated){
    if(isDcp){
      sessionStorage.setItem(SSO_RETURN_KEY, window.location.pathname + window.location.search)
      return <Navigate to="/sso" replace />
    }else{
      return <Navigate to="/logout" />
    }
  }
  return <>{children}</>
}
